/* eslint-disable jira/filename-case */
export const PACKAGE_NAME = '@jira/navigation-apps__atlassian-navigation' as const;
export const TEAM_NAME = 'navigation' as const;

export const TOP_LEVEL_ERROR_BOUNDARY_ID = 'TOP_LEVEL';

export const NAVIGATION_ITEM_ID = {
	ADDONS: 'apps',
	CREATE: 'createIssue',
	APP_SWITCHER: 'atlassianSwitcher',
	DASHBOARDS: 'dashboards',
	FILTERS: 'filters',
	HELP: 'help',
	HELP_BADGE: 'helpBadge',
	HOME: 'home',
	INSIGHT: 'insight',
	LOGO: 'productLogo',
	NOTIFICATIONS: 'notifications',
	PLANS: 'plans',
	PROFILE: 'profile',
	PROJECTS: 'projects',
	ROADMAPS: 'roadmaps',
	SEARCH: 'search',
	SERVICE_HUB: 'services',
	SETTINGS: 'settings',
	SIGN_IN: 'signIn',
	CONVERSATION_ASSISTANT: 'conversationAssistant',
	ROVO_DEMAND_TESTS: 'rovoDemandTests',
} as const;

export const MODAL_ID = {
	DASHBOARD_CREATE: 'DASHBOARD_CREATE',
	KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
	PROJECT_CREATE: 'PROJECT_CREATE',
} as const;

export const PROFILE_SPOTLIGHT_KEY = 'profile-spotlight';
export const HELP_SPOTLIGHT_KEY = 'help-spotlight';
export const HELP_SPOTLIGHT_EVENT_NAME = 'jira-nav-help-spotlight';

export const EXPERIENCE_NAVIGATION_TOP_MENU = 'viewAtlassianNavigationMenu';

export const JSW_TMP_BACKLOG_BOARD_REGEXP: RegExp =
	/jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
